import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, ArrowLeft, AlertCircle } from 'lucide-react';
import { cn } from '../lib/utils';

const NotFoundPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-white dark:bg-gray-950 px-4">
      <div className="max-w-md w-full text-center">
        <div className="mb-8 flex justify-center">
          <div className="relative">
            <div className="absolute inset-0 bg-emerald-500/20 blur-3xl rounded-full" />
            <div className="relative bg-emerald-500/10 p-6 rounded-full">
              <AlertCircle size={64} className="text-emerald-600 dark:text-emerald-400" />
            </div>
          </div>
        </div>

        <h1 className="text-6xl font-black text-gray-900 dark:text-white mb-4 tracking-tight">
          404
        </h1>

        <h2 className="text-xl font-black text-gray-700 dark:text-gray-300 mb-3 uppercase tracking-tight">
          Page Not Found
        </h2>

        <p className="text-sm text-gray-500 dark:text-gray-400 mb-8 leading-relaxed">
          The page you're looking for doesn't exist or has been moved.
          {location.pathname && (
            <span className="block mt-2 font-mono text-xs text-gray-400 dark:text-gray-500">
              {location.pathname}
            </span>
          )}
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => navigate(-1)}
            className={cn(
              "flex items-center justify-center gap-2 px-6 py-3 rounded-xl",
              "bg-gray-100 dark:bg-gray-900 hover:bg-gray-200 dark:hover:bg-gray-800",
              "text-gray-700 dark:text-gray-300 font-bold text-sm uppercase tracking-tight",
              "transition-all duration-200 hover:scale-105",
              "border border-gray-200 dark:border-gray-800"
            )}
          >
            <ArrowLeft size={16} />
            Go Back
          </button>

          <button
            onClick={() => navigate('/')}
            className={cn(
              "flex items-center justify-center gap-2 px-6 py-3 rounded-xl",
              "bg-emerald-600 hover:bg-emerald-700",
              "text-white font-bold text-sm uppercase tracking-tight",
              "transition-all duration-200 hover:scale-105",
              "shadow-lg shadow-emerald-200/50 dark:shadow-emerald-900/50"
            )}
          >
            <Home size={16} />
            Go Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
